import { __decorate } from "tslib";
import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
/**
 * CardDetails Component
 */
let CardPaymentDetailsComponent = class CardPaymentDetailsComponent {
    constructor(httpClient, change) {
        this.httpClient = httpClient;
        this.change = change;
        this.cardPaymentRequestDetails = {};
        this.arrayOfDetails = [];
        this.gatewayURL = '';
    }
    ngOnInit() { }
    paymentRequestDetails(txId) {
        this.httpClient.get('cardpaymentdetails?txid=' + txId).subscribe((result) => {
            this.cardPaymentRequestDetails = result;
            if (screen.width <= 640) {
                this.cardPaymentRequestDetails["mobileMode"] = true;
            }
            this.gatewayURL = this.cardPaymentRequestDetails["gatewayURL"];
            delete this.cardPaymentRequestDetails['gatewayURL'];
            this.arrayOfDetails = Object.keys(this.cardPaymentRequestDetails).map(key => ({ key, value: this.cardPaymentRequestDetails[key] }));
            this.change.detectChanges();
            this.detailsForm.nativeElement.submit();
        });
    }
};
CardPaymentDetailsComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: ChangeDetectorRef }
];
__decorate([
    ViewChild('detailsForm', { static: true })
], CardPaymentDetailsComponent.prototype, "detailsForm", void 0);
CardPaymentDetailsComponent = __decorate([
    Component({
        selector: 'ecd-card-payment-details',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./card-payment-details.component.html")).default
    })
], CardPaymentDetailsComponent);
export { CardPaymentDetailsComponent };
